<template>
  <div class="login-container"
       :style="{ 'background-image': 'url(' + loginBgImage + ')' }">
    <div class="login-box">
      <el-form ref="loginForm"
               :model="loginForm"
               :rules="loginRules"
               class="login-form"
               auto-complete="on"
               label-position="left">
        <el-form-item>
          <h2 class="title">
            Hello！
          </h2>
          <h3 class="title">
            {{ title || "AiBEE 盘古标注平台" }}
          </h3>
        </el-form-item>
        <el-form-item prop="username">
          <el-input v-model="loginForm.username"
                    name="username"
                    type="text"
                    auto-complete="on"
                    placeholder="请输入用户名" />
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="loginForm.password"
                    :type="pwdType"
                    name="password"
                    auto-complete="on"
                    placeholder="请输入密码"
                    @keyup.enter.native="handleLogin" />
        </el-form-item>
        <el-form-item v-if="verify_image"
                      prop="verify_code"
                      class="verify-code">
          <el-input v-model="loginForm.verify_code"
                    style="width: 150px"
                    name="username"
                    type="text"
                    auto-complete="on"
                    placeholder="请输入验证码"
                    @keyup.enter.native="handleLogin" />
          <img style="cursor: pointer;"
               :src="base64Prefix + verify_image"
               @click="verifyCode">
        </el-form-item>
        <el-form-item style="margin-top: 20px;">
          <el-button :loading="loading"
                     type="primary"
                     round
                     style="width:50%;"
                     @click.native.prevent="handleLogin">
            登 录
          </el-button>
          <!-- <span style="margin-left:15px;">
            没有账号？<a class="btn-register"
                    @click="toRegister">立即注册</a>
          </span> -->
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import systemConfig from '@/config';
import { uuid } from '@/utils/index';
import { getVerifyCode } from '@/api/login';

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        uuid: undefined,
        username: '',
        password: '',
      },
      loginRules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        // verify_code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
      title: systemConfig.title,
      loginBgImage: null,
      loading: false,
      pwdType: 'password',
      redirect: undefined,
      verify_image: null,
      base64Prefix: 'data:image/jpeg;base64,',
      ttt: false, // 临时，等多次密码错误接口修改后去除
    };
  },
  computed: {
    ...mapGetters(['theme']),
  },
  watch: {
    $route: {
      handler(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  created() {
    // eslint-disable-next-line
    this.loginBgImage = require(`../../assets/image/login-${this.theme}.png`);
    if (systemConfig.useVerifyCode) {
      this.verifyCode();
    }
  },
  methods: {
    toRegister() {
      this.$router.push({
        path: '/register',
      });
    },
    showPwd() {
      if (this.pwdType === 'password') {
        this.pwdType = '';
      } else {
        this.pwdType = 'password';
      }
    },
    verifyCode() {
      this.loginForm.uuid = uuid();
      getVerifyCode(this.loginForm.uuid).then((res) => {
        this.verify_image = res.data.verify_image;
      });
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch('Login', this.loginForm)
            .then(() => {
              this.loading = false;
              delete this.$route.query.redirect;
              this.$router.push({ path: this.redirect || '/', query: this.$route.query });
            })
            .catch((res) => {
              this.loading = false;
              if ([10001, 10002, 10003, 10004].includes(res.err_no || res.error_no)) {
                this.ttt = true;
                this.verify_image = res.data.verify_image;
              } else if (systemConfig.useVerifyCode) {
                this.verifyCode();
              }
            });
        } else {
          console.log('error submit!!');
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.verify-code {
  img {
    margin-left: 20px;
    display: inline-block;
    vertical-align: middle;
    max-height: 50px;
  }
}
.btn-register {
  font-size: 14px;
  text-decoration: underline;

  &:hover {
    font-weight: 600;
  }
}
</style>
